import { useMyPageRouter } from './useMyPageRouter';
const useEvent = () => {
    const { formatQuery, onBlurKeyword, onClickSort, onPageChange, pathname, query, } = useMyPageRouter.useQueryParams([
        { initial: 1, name: 'page', type: 'integer' },
        { initial: '', name: 'searchText', type: 'string' },
        { name: 'sort', selects: ['created_at'] },
        { name: 'order', selects: ['desc', 'asc'] },
    ]);
    return {
        formatQuery,
        onBlurKeyword,
        onClickSort,
        onPageChange,
        pathname,
        query,
    };
};
export const useMyPageShareHistory = {
    useEvent,
};
export default useMyPageShareHistory;
